import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const LIST_PROMOTION_CODES = "PROMOTION-CODE:LIST_PROMOTION_CODES";

export interface ListPromotionCodesAction extends Action {
  type: typeof LIST_PROMOTION_CODES;
  organization: OrganizationKeyName;
  page: number;
  filters: { [i: string]: string };
}

export const listPromotionCodesAction = (
  organization: OrganizationKeyName,
  page: number,
  filters: { [i: string]: string }
): ListPromotionCodesAction => ({
  type: LIST_PROMOTION_CODES,
  organization,
  page,
  filters,
});
